module.exports = __webpack_public_path__ + "static/quentin-mameri-recadree-ce23579972c850a4ddd7a1a198f550b9.png";